import React from 'react';
import '../Styles/checkbox.scss';

export const CustomCheckbox = ({ 
  id, 
  label, 
  checked = false, 
  disabled = false, 
  size = 'default', 
  onChange,
  className = '',
  ...props 
}) => {
  const handleChange = (e) => {
    if (onChange) {
      onChange(e.target.checked, e);
    }
  };

  const handleContainerClick = () => {
    if (!disabled && onChange) {
      onChange(!checked);
    }
  };

  const sizeClass = size !== 'default' ? `custom-checkbox--${size}` : '';
  
  return (
    <div className={`custom-checkbox ${sizeClass} ${className}`} onClick={handleContainerClick}>
      <input
        type="checkbox"
        id={id}
        className="checkbox-input"
        checked={checked}
        disabled={disabled}
        onChange={handleChange}
        onClick={(e) => e.stopPropagation()}
        {...props}
      />
      <div className="checkbox-custom"></div>
      {label && (
        <label htmlFor={id} className="checkbox-label" onClick={(e) => e.stopPropagation()}>
          {label}
        </label>
      )}
    </div>
  );
};

export const CheckboxList = ({ title, children, className = '' }) => {
  return (
    <div className={`checkbox-list ${className}`}>
      {title && <div className="checkbox-list__title">{title}</div>}
      {children}
    </div>
  );
};